import {Player} from "@lottiefiles/react-lottie-player";
import loader from "../../assets/loading/loading.json";
import * as React from "react";

export default function PageLoader() {
    return(
        <div style={{
            position: 'fixed',
            left: 0,
            bottom: 0,
            width: '100%',
            height: '100vh',
            background: 'rgba(255, 255, 255, 0.8)',
            zIndex: 50000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <Player
                src={loader}
                className="question-finish-loader"
                style={{height: "200px", width: "200px"}}
                loop
                autoplay
            />
        </div>
    )
}